import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const baseClasses = `block w-full max-w-lg mx-auto bg-[#4A7C59] text-white text-xl md:text-2xl font-bold py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(74,124,89,0.4)] hover:bg-[#3D6B4A] transition-colors text-center uppercase tracking-wide ${className}`;
  const animationProps = {
    animate: {
      scale: [1, 1.02, 1]
    },
    transition: {
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    },
    whileHover: {
      scale: 1.05
    },
    whileTap: {
      scale: 0.95
    }
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-18">
      {href ? <motion.a href={href} className={baseClasses} {...animationProps} onClick={onClick} data-id="element-19">
          {children}
        </motion.a> : <motion.button onClick={onClick} className={baseClasses} {...animationProps} data-id="element-20">
          {children}
        </motion.button>}
      <div className="flex flex-col items-center gap-1.5 mt-3" data-id="element-21">
        <div className="flex items-center justify-center gap-1.5 text-xs text-[#586880] font-medium" data-id="element-22">
          <ShieldCheck size={14} className="text-[#4A7C59]" data-id="element-23" />
          <span data-id="element-24">7 días de garantía total — Sin preguntas</span>
        </div>
        <div className="flex items-center justify-center gap-1.5 text-xs text-[#586880] font-medium" data-id="element-25">
          <Lock size={12} className="text-[#586880]" data-id="element-26" />
          <span data-id="element-27">Pago protegido por Mercado Pago</span>
        </div>
      </div>
    </div>;
}